var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top d-none d-xl-block"
  }, [_c('v-container', [_c('div', {
    staticClass: "d-flex justify-space-between align-start"
  }, [_c('client-gnb', {
    attrs: {
      "className": "footer-gnb"
    }
  }), _c('div', {
    staticClass: "lang"
  }, [_c('p', {
    staticClass: "lang_li"
  }, [_vm._v("KR")]), _c('a', {
    staticClass: "lang_li",
    attrs: {
      "href": "/en"
    }
  }, [_vm._v("EN")])])], 1)])], 1), _c('div', {
    staticClass: "footer-bottom"
  }, [_c('v-container', [_c('div', {
    staticClass: "d-xl-flex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "d-lg-flex align-start mb-8 mb-lg-20 mb-xl-0"
  }, [_c('img', {
    staticClass: "d-block mb-30 mb-lg-0",
    attrs: {
      "src": "/images/footer-ci.svg",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "footer-info"
  }, [_c('p', {
    staticClass: "line-height-1 mb-8"
  }, [_vm._v("아이에스티")]), _c('p', [_vm._v(" 대표: 황정호"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("ㅣ")]), _c('br', {
    staticClass: "mo"
  }), _vm._v(" 주소: 경기도 광주시 오포읍 오포로 673-10"), _c('br'), _vm._v(" TEL : 031-765-2268"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("ㅣ")]), _c('br', {
    staticClass: "mo"
  }), _vm._v(" FAX: 031-765-2389"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "30px"
    }
  }, [_vm._v("ㅣ")]), _c('br', {
    staticClass: "mo"
  }), _vm._v(" 사업자등록번호 : 211-86-59880 ")])])]), _c('p', [_vm._v("Copyright © 2022 IST. All Rights Reserved")])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }